import { cn } from '../../utils/helpers';
import { forwardRef } from 'react';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'flat' | 'elevated';
  children?: React.ReactNode;
}

const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ variant = 'default', className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'rounded-sm',
          variant === 'default' && 'bg-bg-panel border border-border',
          variant === 'flat' && 'bg-bg-panel',
          variant === 'elevated' && 'bg-bg-panel border border-border shadow-sm',
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);
Card.displayName = 'Card';

interface CardHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

export function CardHeader({ title, subtitle, actions, className, children, ...props }: CardHeaderProps) {
  return (
    <div className={cn('px-4 py-3 border-b border-border flex items-center justify-between', className)} {...props}>
      <div>
        {title && <h3 className="text-sm font-semibold text-text-primary">{title}</h3>}
        {subtitle && <p className="text-xs text-text-muted mt-0.5">{subtitle}</p>}
      </div>
      {actions && <div>{actions}</div>}
      {children}
    </div>
  );
}

interface CardBodyProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

export function CardBody({ children, className, ...props }: CardBodyProps) {
  return (
    <div className={cn('p-4', className)} {...props}>
      {children}
    </div>
  );
}

export { Card };
